var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRightDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60722 19.9997C8.39699 20.0009 8.18858 19.9606 7.99394 19.8812C7.79931 19.8017 7.62229 19.6845 7.47302 19.5365C7.32329 19.388 7.20445 19.2113 7.12335 19.0166C7.04224 18.8219 7.00049 18.6131 7.00049 18.4023C7.00049 18.1914 7.04224 17.9826 7.12335 17.7879C7.20445 17.5932 7.32329 17.4166 7.47302 17.268L12.7607 12.0124L7.68069 6.72472C7.38316 6.42542 7.21616 6.02053 7.21616 5.5985C7.21616 5.17647 7.38316 4.77159 7.68069 4.47229C7.8292 4.32256 8.00588 4.20371 8.20055 4.12261C8.39521 4.04151 8.60401 3.99976 8.8149 3.99976C9.02578 3.99976 9.23458 4.04151 9.42925 4.12261C9.62391 4.20371 9.8006 4.32256 9.9491 4.47229L16.1154 10.8622C16.4081 11.1608 16.572 11.5623 16.572 11.9804C16.572 12.3986 16.4081 12.8 16.1154 13.0986L9.72546 19.4885C9.58207 19.6434 9.40942 19.7683 9.21749 19.856C9.02556 19.9438 8.81814 19.9926 8.60722 19.9997Z",
    fill: "#D6D6D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightDisabled);
export default __webpack_public_path__ + "static/media/chevron-right-disabled.9587e2de70b9fcc52c2537a7b589b9ad.svg";
export { ForwardRef as ReactComponent };